<template>
  <q-page padding>
    <h4 class="text-center" style="padding:0;margin:0">Colours Table</h4>
    <div class="q-pa-md row justify-end">
      <q-toggle :label="`${editMode ? 'Exit Edit Mode':'Enable Edit Mode'}`" color="primary" v-model="editMode" />
    </div>
    <template v-if="loaded">
      <q-card class="q-pa-md">
        <q-markup-table separator="cell" wrap-cells>
          <thead style="background-color:#f0f0f0;">
            <tr>
              <th></th>
              <th></th>
              <th v-for="(headerData,index) in colHeaders" :key="index" style="font-weight:bold">{{headerData.manufacturer}}</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th v-for="(headerData,index) in colHeaders" :key="index">
                <div v-for="(brand,index) in headerData.brands" :key="index" style="font-weight:bold">{{brand}}</div>
              </th>   
            </tr>
          </thead>
          <tbody>
            <template v-for="(rowData,index) in rowHeaders">
              <tr v-for="(row,rowIndex) in rowData.groups" :key="rowIndex+row+index">
                <td rowspan="5" v-if="rowIndex == 0" :style="{'backgroundColor':rowData.supergroup,'color':contrast(rowData.supergroup)}">{{rowData.supergroup}}</td>
                <td>{{row}}</td>
                <template v-for="(headerData,headerIndex) in colHeaders" >
                  <template v-if="findColourFromTable(row,headerData).length > 0" >
                    <td :key="colourIndex+headerData.brands" v-for="(colour,colourIndex) in findColourFromTable(row,headerData)" :style="{'backgroundColor':colour.hex,'textAlign':'center','color':contrast(colour.hex,true)}">
                      <template v-if="colour.name == 'Error'">  
                        <span>
                          <q-icon size="md" name="warning" color="red"></q-icon>
                          <q-tooltip>There are 2 or more colours assigned to the same manufacturer/brand and subgroup</q-tooltip>
                        </span>
                      </template>
                      <template v-else>
                        {{colour.name}} 
                      </template>
                      <q-btn dense color="primary" size="xs" icon="create" style="margin-left:10px" v-if="editMode && colour.name != 'Error'" :to="{ path: '/admin/edit-colour/' + colour.id, exact: true }"/>
                    </td>
                  </template>
                  <template v-else>
                    <td :key="headerIndex" class="text-center">
                      <q-btn :to="{ path: '/admin/add-colour-link', query:{supergroup:rowData.supergroup,group:row,manufacturer:headerData.manufacturer,brandID:headerData.brandID}, exact: true }" flat dense size="sm" label="Add New" style="margin-left:10px" v-if="editMode"/>
                    </td>
                  </template>
                </template>
              </tr>
            </template>
          </tbody>
        </q-markup-table>
      </q-card>
    </template>
  </q-page>
</template>

<script>
import gql from "graphql-tag";
import _ from 'lodash';
import notifyMessage from '../../util/notifyMessage'
import notifyError from '../../util/adminNotifyError'
import { contrastColor } from 'contrast-color';

export default {
  name: 'ColoursTable',
  data(){
    return{
      editMode: false,
      loaded: false,
      manufacturersBrands: {
        "360": [ { brandID: 4, brands: [ "360"] } ],
        Aragon: [ 
          { brandID: 0, brands: [ "Elevation" ] }, 
          { brandID: 1, brands: [ "Kingdom", "Working Class" ] }, 
          { brandID: 2, brands: [ "Kilter", "Urban Plastix", "Flathold" ] } ],
        blocSyndicate: [ { brandID: 6, brands: [ "Satellite" ] } ],
        COMPX: [ { brandID: 3, brands: [ "Flathold", "Kilter", "Cheeta", "Kingdom", "Urban Plastix", "AiX" ] } ],
        "COMPX PU": [ { brandID: 5, brands: [ "Working Class", "AiX", "Kingdom" ] } ],
        Dimension: [ { brandID: 7, brands: [ "Dimension" ] } ]
      },
      supergroupNames: []
    }
  },
  methods: {
    contrast(bg){
      return contrastColor({ bgColor: bg?.toLowerCase() })
    },
    findColourFromTable(group,manufacturerBrand){
      let coloursFound = []
      for(let colour of this.results){
        if(colour.group == group){
          if(manufacturerBrand.string == JSON.stringify({manufacturer:colour.manufacturer,brands:colour.brands})){
            coloursFound.push(colour)
          }
        }
      }
      if(coloursFound.length == 1){
        return coloursFound;
      }

      if(coloursFound.length > 1){
        notifyError(this.$q,"Error loading colour",{message:`More that one colour found for "${group}" - ${JSON.stringify(manufacturerBrand)}`})
        console.log("ERROR, MORE THAT ONE COLOUR FOUND")
        return [{name:"Error"}]
      }
      if(coloursFound.length == 0){
        return ""
      }
    },
    generateGroupColourList(SuperGroupColour){
      let groupList = []
      if(SuperGroupColour){
        groupList = ["Light","","Dark","Bright","Fluoro"]
        for(let i = 0; i<groupList.length; i++){
          let group = groupList[i] + " " + SuperGroupColour;
          groupList[i] = group.trim()
        }
      }
      return groupList
    },
    getBrandID(brandsArray){     
      for(let manbrand in this.manufacturersBrands){
        let brands = this.manufacturersBrands[manbrand]
        const found = brands.find(element => _.isEqual(_.sortBy(element.brands), _.sortBy(brandsArray)));
        if(found){          
          return found.brandID
        }
      }
    },
    async loadColourTable(){
      try{
        this.results = await this.getColours_query();
        let allsupergroups = []
        let allManBrands = [] 
        this.rowHeaders = []
        this.colHeaders = []
        for(let colour of this.results){
          allsupergroups.push(colour.supergroup)
          allManBrands.push(JSON.stringify({manufacturer:colour.manufacturer,brands:colour.brands}))
        }
        let uniqueItems = [...new Set(allsupergroups)]
        let uniqueManBrands = [...new Set(allManBrands)]

        for(let manBrand of  uniqueManBrands ){
          let parsed = JSON.parse(manBrand)
          this.colHeaders.push({...parsed,string:manBrand,brandID:this.getBrandID(parsed.brands)})
        }

        for(let supergroup of uniqueItems){
          console.log(supergroup,"-",this.contrast(supergroup));
    
          let groups = this.generateGroupColourList(supergroup);
          this.rowHeaders.push({supergroup:supergroup,groups:groups})
        }
        this.loaded = true;
        return true
      }catch(error){
        notifyError(this.$q,"Error deleting colour",error)
      }
    },
    //Query FUNCTIONS
    async getColours_query(){
      try {
        const result = await this.$apollo.query({
          query: gql`query colours {
            colours {
              id
              name
              supergroup
              group
              hex
              manufacturer
              brands
              materials
              notes
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        return result.data.colours;
      } catch (error) {
        console.log("getColours_query Error:", error)
        throw new Error(error);    
      }      
    },     
  },
  mounted(){
    this.loadColourTable()
  }
}
</script>